<template>
  <div class="content">
    <div class="bg">
      <div class="block">
        <div class="item mb14">
          <span class="star">*</span>
          <p class="topic">
            <i v-show="item.selected" v-for="item in topicList" :key="item.title">【{{item.title}}】</i>
            <input class="enter" v-model="topic" type="text" :placeholder="`请输入选题`" maxlength="100">
            <span class="count">{{`${topic.length}/100`}}</span>
          </p>
        </div>
        <div class="topicList">
          <p @click="item.selected = !item.selected" v-for="item in topicList" :key="item.title" :class="{on: item.selected}">{{item.title}}</p>
        </div>
        <div class="item">
          <span class="star">*</span>
          <div class="autoSelector">
            <div :class="{depart: true, on: showDepart}" @click="toggleDepart()">
              <span :class="{department: true, filled: selectedDep.title}">{{selectedDep.title || '请选择部门'}}</span>
              <img class="icon" :src="showDepart ? icons.up: icons.down" alt="arrow">
            </div>
            <div class="selections" v-if="showDepart">
              <p class="opt" v-for="(d, i) in deps" :key="i" @click="selectdep(d)">
                <span>{{d.title}}</span>
                <img v-if="d.id === selectedDep.id" src="@assets/img/interview/select.svg" alt="select">
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <span class="star">*</span>
          <div class="autoSelector">
            <div :class="{reporter: true, on: focusInputing}">
              <span v-show="s.selected" class="selectd" v-for="(s, i) in reporters" :key="i">
                <span>{{s.truename}}</span>
                <img class="close" src="@assets/img/interview/del.svg" alt="close" @click="unSelectReporter(s)">
              </span>
              <input class="enter" type="text" placeholder="请选择执行人" @focus="focusInput()" @blur="blurInput()" v-model="reporter" @keyup="searchReporters()">
              <img src="@assets/img/interview/reporter.svg" alt="reporter">
            </div>
            <div class="selections" v-if="focusInputing">
              <p class="opt" v-for="(r, d) in reporters" :key="d" @mousedown="selectReporter(r)" v-show="!r.hide">
                <span>{{r.truename}}</span>
                <img v-if="r.selected" src="@assets/img/interview/select.svg" alt="select">
              </p>
            </div>
          </div>
        </div>
        <div class="item">
          <span class="star">*</span>
          <date-picker v-model="datePicker" placeholder="请选择日期" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" :type="'date'" :format="'YYYY-MM-DD'" confirm></date-picker>
        </div>
      </div>
      <div class="block">
        <p class="title">
          {{`其他选项`}}
        </p>
        <div class="otherItem">
          <div class="t">重要选题</div>
          <el-switch
            v-model="importantTopic"
            active-color="#41B48C">
          </el-switch>
        </div>
        <div class="otherItem">
          <div class="t">查看范围</div>
          <div class="radio">
            <p @click="view_scope = 0" :class="{on: view_scope == 0}"><i></i><span>公开</span></p>
            <p @click="view_scope = 1" :class="{on: view_scope == 1}"><i></i><span>保密</span></p>
          </div>
        </div>
      </div>
      <div v-show="has_interview_role" class="block">
        <p class="title">
          {{`关联采访`}}
        </p>
        <div class="linkTopic">
          <p class="linkBtn" @click="openLink()">
            <img src="@assets/img/interview/link.svg" alt="link">
            <span>{{`关联采访`}}</span>
          </p>
          <span :class="{linkMsg: true}">可关联多条采访</span>
        </div>
        <ul class="selectInterview">
          <li v-for="(item, index) in withInterview" :key="index">
            <p>{{item.title}}</p>
            <i @click="delInterview(index)"></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="footLine" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <span v-show="!isChange" :class="{'btn': true, 'disabled': posting}" @click="addNew()">提交</span>
      <span v-show="!isChange" class="btn gray" @click="goBack()">取消</span>
      <span v-show="isChange" :class="{'btn': true, 'disabled': posting}" @click="addNew('pass')">修改并通过</span>
      <span v-show="isChange" class="btn gray" @click="addNew('save')">修改</span>
    </div>
    <withTopic :from="1" ref="withTopic" @getTopic="getLink" />
    <withInterview :from="22" ref="withInterview" @getInterview="fetchInterview" />
    <location ref="location" @getLocation="getLocate" />
    <successTip ref="successTip" />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import counter from '@components/counter'
import withTopic from '@components/withTopic'
import withInterview from "@components/withNewInterview";
import location from '@components/location'
import common from '@common/common'
import {apis} from '@common/config'
import dc from '@common/dc'
import successTip from '@components/successTip'
import { Switch } from 'element-ui'
import vClickOutside from "v-click-outside";

export default {
  name: 'newInterview',
  directives: {
      clickOutside: vClickOutside.directive
  },
  components: {
    DatePicker, counter, withTopic, location, successTip,'el-switch': Switch, withInterview
  },
  data() {
    return {
      importantTopic: false,
      topicList: [{
        title: '电视',
        selected: false
      },{
        title: '新媒体',
        selected: false
      },{
        title: '直播',
        selected: false
      },{
        title: '海报',
        selected: false
      },],
      icons: {
        up: require('@assets/img/interview/up.svg'),
        down: require('@assets/img/interview/down.svg')
      },
      topic: '',
      showDepart: false,
      datePicker: '',
      locate: '',
      reporter: '',
      reporters: [],
      deps: [],
      selectedDep: {},
      focusInputing: false,
      remark: '',
      bases: [],
      expands: [],
      associate: {},
      timeBefore: '', // 当前日期开始时间，用于时间插件禁选功能
      posting: false,
      footLineGap: 230,
      enableAssociate: false,
      withInterview: [],
      view_scope: 0,
      has_interview_role: false,
      isChange: false,
      lockInterval: null
    }
  },
  watch: {
    datePicker: function(n, o) {
      // this.timeBefore = common.stampToTime(n[0]) || this.getTomarrowTime()[0]
      this.timeBefore = this.getTodayStart()
    }
  },
  methods: {
    delInterview(index) {
      this.withInterview = this.withInterview.filter((i,key) => {
        return index != key
      })
    },
    fetchInterview(i) {
      // 获取关联采访
      this.withInterview = (this.withInterview || []).concat(i);
    },
    goBack() {
      // window.history.go(-1)

      window.close()
    },
    searchReporters() {
      // 筛选记者
      this.reporters.forEach((i) => {
        this.$set(i, 'hide', true)
      })

      this.reporters.forEach((i) => {
        if (i.username.indexOf(this.reporter) > -1 || i.truename.indexOf(this.reporter) > -1) {
          this.$set(i, 'hide', false)
        }
      })
    },
    toggleDepart(){
      // 切换部门
      this.showDepart = !this.showDepart
    },
    getBaseCounter(d) {
      // 接收基础类数量
      this.matchResources(d, this.bases)
    },
    getSubCounter(d) {
      // 接收拓展类数量
      this.matchResources(d, this.expands)
    },
    matchResources(d, l) {
      // 将接收到的资源数量数据同步到数据模型
      l.forEach((i) => {
        if (d.name === i.rc_name) {
          i.num = d.value
        }
      })
    },
    selectReporter(r) {
      // 选择记者
      this.$set(r, 'selected', true)
      this.reporter = ''
      this.searchReporters()
      // this.focusInputing = true
    },
    selectdep(d) {
      // 选择部门
      this.selectedDep = d
      this.showDepart = false
    },
    unSelectReporter(r) {
      // 反选记者
      this.$set(r, 'selected', false)
    },
    blurInput() {
      // 记者输入框失去焦点
      this.focusInputing = false
    },
    focusInput() {
      // 记者输入框获取焦点
      let arr = []
      this.reporters.forEach(r => {
        if(r.selected){
          arr.push(r)
        }
      })

      if(arr.length < 10){
        this.focusInputing = true
      }else{
        this.$toast('最多只能选择10位执行人')
      }
    },
    getLink(t) {
      // 接收关联选题
      this.associate = t

      setTimeout(() => {
        dc.delTpc()
      }, 500)
    },
    fromTopic() {
      // 接收选题数据
      // const t = this.$route.params.topic
      const t = dc.getTpc()

      if (t) {
        this.getLink(t)
      }
    },
    getLocate(l) {
      // 接收所选地理位置
      this.locate = l
    },
    closePops() {
      // 关闭记者和部门菜单
      this.focusInputing = false
      this.showDepart = false
    },
    openLink() {
      // 打开关联选题弹窗
      this.closePops()
      this.$refs.withInterview.open()
    },
    openLocation() {
      // 打开地理位置弹窗
      this.closePops()
      this.$refs.location.open()
    },
    getData() {
      // 获取配置数据
      common.myFetch(apis.newTopicInit, {})
      .then((data) => {
        console.log(data)
        this.deps = data.departs
        this.reporters = data.executor
        this.has_interview_role = data.has_interview_role

        if(this.$route.query.r){
          this.getDetail()
        }else{
          if(this.deps && this.deps.length == 1){
            this.selectdep(this.deps[0])
          }

          if(data.self && data.self.id){
            data.executor.forEach(i => {
              if(i.id == data.self.id){
                this.$set(i, 'selected', true)
              }
            })
          }
        }
        // this.expands = data.sub_classs
        // this.bases = data.bass_class
        // // this.reporters = this.getdefaultReporter()
        // this.getDefaultDepartmentAndReporter()
        // this.enableAssociate = !!data.topicExist
      })
    },
    getDefaultDepartmentAndReporter() {
      // 默认选择部门和其中的记者
      this.deps.forEach((i) => {
        if (i.selected) {
          this.selectdep(i)
        }
      })
    },
    getdefaultReporter() {
      // 默认选中记者列
      let reporters = []
      this.deps.forEach(i => {
        i.reporters.forEach(j => {
          if (j.selected) {
            reporters = i.reporters
          }
        })
      })

      return reporters
    },
    formReporter(d) {
      // 将记者数据组装为接口格式
      const r = []
      d.forEach(i => {
        if (i.selected) {
          r.push(`${i.id}#${i.name}`)
        }
      })

      return r.join(',')
    },
    formClass(d) {
      // 将资源（基础、拓展）数据组装为接口格式
      const r = []
      d.forEach(i => {
        r.push(`${i.rc_id}:${i.rc_name}:${i.num || 0}`)
      })

      return r.join(';')
    },
    doubleDigit(n) {
      // 将数字转为两位，不足补零
      if (n / 10 < 1) {
        return `0${n}`;
      }

      return `${n}`;
    },
    stampToDate(s) {
      // 将时间戳转换为时间
      if (!s) {
        return "";
      }

      const year = s.getFullYear();
      const month = this.doubleDigit(s.getMonth() + 1);
      const day = this.doubleDigit(s.getDate());

      return `${year}-${month}-${day}`;
    },
    addNew(action) {
      // 提交新增数据
      if (this.posting) return
      let tags = ''
      this.topicList.forEach(i => {
        if (i.selected) {
          tags += '【'+i.title+'】'
        }
      })
      let title = tags+this.topic
      const depart_id = this.selectedDep.id
      const depart_name = this.selectedDep.title
      const date = this.datePicker ? this.stampToDate(this.datePicker) : ''
      let reporters = []
      this.reporters.forEach(i => {
        if (i.selected) {
          reporters.push(i.id)
        }
      })
      reporters = reporters.join(',')
      let withInterviewId = []
      this.withInterview.forEach(i => {
        withInterviewId.push(i.id)
      })
      withInterviewId = withInterviewId.join(',')
      const required = common.allRequired([title, depart_id, date, reporters])

      if (!required) {
        this.$toast('必填项不可为空')
        return
      }

      const info = {
        title: title,
        depart_id: depart_id,
        depart_name: depart_name,
        date: date,
        is_important: this.importantTopic ? 1 : 0,
        view_scope: this.view_scope,
        interview_ids: withInterviewId,
        executor_ids: reporters,
        id: this.$route.query.r ? this.$route.query.r : '',
        action: action ? action : 'submit'
      }
      
      this.posting = true
      common.myFetch(apis.newTopicRelease2, info)
      .then((data) => {
        if (data) {
          const info = {
            msg: data,
            tip: '页面即将关闭'
          }

          this.$refs.successTip.open(info)
        } else {
          this.posting = false
        }
      })
    },
    addPass() {
      // 提交新增数据
      if (this.posting) return
      let tags = ''
      this.topicList.forEach(i => {
        if (i.selected) {
          tags += '【'+i.title+'】'
        }
      })
      let title = tags+this.topic
      const depart_id = this.selectedDep.id
      const depart_name = this.selectedDep.title
      const date = this.datePicker ? this.stampToDate(this.datePicker) : ''
      let reporters = []
      this.reporters.forEach(i => {
        if (i.selected) {
          reporters.push(i.id)
        }
      })
      reporters = reporters.join(',')
      let withInterviewId = []
      this.withInterview.forEach(i => {
        withInterviewId.push(i.id)
      })
      withInterviewId = withInterviewId.join(',')
      const required = common.allRequired([title, depart_id, date, reporters])

      if (!required) {
        this.$toast('必填项不可为空')
        return
      }

      const info = {
        title: title,
        depart_id: depart_id,
        depart_name: depart_name,
        date: date,
        is_important: this.importantTopic ? 1 : 0,
        view_scope: this.view_scope,
        interview_ids: withInterviewId,
        executor_ids: reporters,
        id: this.$route.query.r ? this.$route.query.r : '',
      }
      
      this.posting = true
      common.myFetch(apis.newTopicRelease2, info)
      .then((data) => {
        if (data) {
          console.log(data)
          const info = {
            ids: this.$route.query.r,
            status: 2
          }

          common.myFetch(apis.newTopicVerify, info)
          .then((data) => {
            if (data) {
              const info = {
                msg: data,
                tip: '页面即将关闭'
              }

              this.$refs.successTip.open(info)
            }
          })
        } else {
          this.posting = false
        }
      })
    },
    getTodayStart() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()
      const startSec = new Date(`${year}-${month}-${day} 00:00:00`)

      return startSec
    },
    getToday() {
      // 获取当日时间戳
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const day = today.getDate()
      const startSec = new Date(`${year}-${month}-${day} 09:00:00`)
      const endSec = new Date(`${year}-${month}-${day} 17:00:00`)

      return [startSec, endSec]
    },
    getTomarrowTime() {
      // 获取明天时间戳
      const today = +new Date()
      const tomarrow = new Date(today+1000*60*60*24)
      const year = tomarrow.getFullYear()
      const month = tomarrow.getMonth() + 1
      const day = tomarrow.getDate()
      const startSec = new Date(`${year}-${month}-${day}`)
      const endSec = new Date(`${year}-${month}-${day} 12:00:00`)

      return startSec
    },
    initDate() {
      // 默认选中当日时间
      const today = this.getTomarrowTime()

      this.datePicker = today
    },
    getDetail() {
      let info = {
        id: this.$route.query.r
      }

      common.myFetch(apis.newTopicDetail, info).then(res => {
        if(res){
          let title = res.detail.title;

          this.topicList.forEach(el => {
            let t = '【'+el.title+'】'
            console.log(title, t)
            if(title.indexOf(t) > -1){
              el.selected = true
            }
          })

          title = title.replace('【电视】', '')
          title = title.replace('【新媒体】', '')
          title = title.replace('【直播】', '')
          title = title.replace('【海报】', '')
          this.topic = title

          this.deps.forEach(el => {
            if(el.id == res.detail.depart_id){
              this.selectedDep = el
            }
          })

          let executor_id = res.detail.executor_id;
          executor_id = executor_id.split(',');

          executor_id.forEach(el => {
            this.reporters.forEach(el1 => {
              if(el == el1.id){
                el1.selected = true
              }
            })
          })

          this.datePicker = new Date(res.detail.date)

          if(res.detail.is_important == 1){
            this.importantTopic = true
          }else{
            this.importantTopic = false
          }

          this.view_scope = res.detail.view_scope
          this.withInterview = res.detail.interviews
        }
      })
    },
    handleLock() {
      const info = {
        id: this.$route.query.r
      };

      common
        .myFetch(apis.newTopicLock, { data: info, hideLoading: true })
        .then(r => {
          if (r) {
            console.log("lock", r);
          }
        });
    }
  },
  mounted() {
    this.getData()
    // this.fromTopic()
    this.initDate()

    if(this.$route.query.type == 'change'){
      this.isChange = true
      if(this.lockInterval){
        clearInterval(this.lockInterval)
        this.lockInterval = null;
      }

      this.lockInterval = setInterval(() => {
        this.handleLock()
      }, 15000)
    }
  }
}
</script>

<style lang="less" src="@assets/css/newTopic/editInterview.less" scoped></style>
